import { a as __extends, _ as __makeTemplateObject, b as __awaiter, e as __generator, f as __read, C as ClientSDKProxyContext } from '../../chunks/chunk-525a49bc.js';
import { Icon } from 'antd';
import React, { Component } from 'react';
import styled from 'styled-components';
import { E as ERROR_NO_SDK_CLIENT } from '../../chunks/chunk-bc685b06.js';
import PinchZoom from 'pinch-zoom-js';
import DOMPurify from 'dompurify';

// Copyright 2020 Cognite AS
var ZoomIn = function () { return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.71 14H15.5L20.49 19L19 20.49L14 15.5V14.71L13.73 14.43C12.59 15.41 11.11 16 9.5 16C5.91 16 3 13.09 3 9.5C3 5.91 5.91 3 9.5 3C13.09 3 16 5.91 16 9.5C16 11.11 15.41 12.59 14.43 13.73L14.71 14ZM5 9.5C5 11.99 7.01 14 9.5 14C11.99 14 14 11.99 14 9.5C14 7.01 11.99 5 9.5 5C7.01 5 5 7.01 5 9.5ZM9 9V7H10V9H12V10H10V12H9V10H7V9H9Z", fill: "black" }))); };

// Copyright 2020 Cognite AS
var ZoomOut = function () { return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14ZM12 9H7V10H12V9Z", fill: "black" }))); };

// Copyright 2020 Cognite AS
var FindInPage = function () { return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 8V19.59L16.17 15.75C16.69 14.96 17 14.02 17 13C17 10.24 14.76 8 12 8C9.24 8 7 10.24 7 13C7 15.76 9.24 18 12 18C13.02 18 13.96 17.69 14.76 17.17L19.19 21.6C18.85 21.85 18.45 22 18 22H5.99C4.89 22 4 21.1 4 20L4.01 4C4.01 2.9 4.9 2 6 2H14L20 8ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z", fill: "black" }))); };

// Copyright 2020 Cognite AS
var Close = function () { return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 13.6019L7.60195 18L6 16.3981L10.3981 12L6 7.60195L7.60195 6L12 10.3981L16.3981 6L18 7.60195L13.6019 12L18 16.3981L16.3981 18L12 13.6019Z", fill: "black" }))); };

var initialState = {
    searchPhrase: '',
    amountOfResults: 0,
    currentResult: 0,
};
var SVGViewerSearch = /** @class */ (function (_super) {
    __extends(SVGViewerSearch, _super);
    function SVGViewerSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.setFocus = function () {
            setTimeout(function () {
                if (_this.searchInput.current) {
                    _this.searchInput.current.focus();
                }
            }, 0);
        };
        _this.resetSearch = function () {
            _this.setState(initialState);
        };
        _this.resetSearchResults = function () {
            var _a = _this.props, svg = _a.svg, searchClassName = _a.searchClassName, currentSearchClassName = _a.currentSearchClassName;
            if (!svg) {
                return;
            }
            var searchResults = svg.querySelectorAll("." + searchClassName);
            if (searchResults.length) {
                Array.from(searchResults).forEach(function (searchResult) {
                    searchResult.classList.remove(searchClassName);
                    searchResult.classList.remove(currentSearchClassName);
                });
            }
        };
        _this.handleMouseDown = function (e) {
            e.stopPropagation();
        };
        _this.handleKeyDown = function (e) {
            if (e.keyCode === 13 && _this.state.amountOfResults) {
                _this.handleNavigateSearchResult(1);
            }
            // Overriding ctrl+F
            var FKeyCode = 70;
            if ((e.ctrlKey || e.metaKey) && e.keyCode === FKeyCode) {
                e.preventDefault();
            }
        };
        _this.handleNavigateSearchResult = function (move) {
            var _a = _this.state, currentResult = _a.currentResult, amountOfResults = _a.amountOfResults;
            var _b = _this.props, svg = _b.svg, zoomOnCurrentAsset = _b.zoomOnCurrentAsset, searchClassName = _b.searchClassName, currentSearchClassName = _b.currentSearchClassName;
            var searchResults = svg.querySelectorAll("." + searchClassName);
            var currentSearchResult = svg.querySelector("." + currentSearchClassName);
            if (!currentSearchResult) {
                return;
            }
            var nextResult = currentResult + move;
            if (move === 1 && nextResult > amountOfResults) {
                nextResult = 1;
            }
            else if (move === -1 && nextResult === 0) {
                nextResult = amountOfResults;
            }
            currentSearchResult.classList.remove(currentSearchClassName);
            searchResults[nextResult - 1].classList.add(currentSearchClassName);
            _this.setState({ currentResult: nextResult });
            zoomOnCurrentAsset(searchResults[nextResult - 1]);
        };
        _this.handleCancelSearch = function () {
            _this.resetSearch();
            _this.resetSearchResults();
            _this.props.handleCancelSearch();
        };
        _this.handleSearchPhraseChange = function (e) {
            var value = e.currentTarget.value;
            var _a = _this.props, svg = _a.svg, addCssClassesToMetadataContainer = _a.addCssClassesToMetadataContainer, addCssClassesToSvgText = _a.addCssClassesToSvgText, zoomOnCurrentAsset = _a.zoomOnCurrentAsset, searchClassName = _a.searchClassName, currentSearchClassName = _a.currentSearchClassName, handleSearchChange = _a.handleSearchChange;
            _this.resetSearchResults();
            if (!value) {
                _this.resetSearch();
            }
            else {
                var regexp_1 = new RegExp("(" + value + ")", 'gi');
                var amountOfResults = 0;
                var currentResult = 0;
                var isMatchingSearchPhrase = function (textNode) {
                    return !!(textNode.textContent && textNode.textContent.match(regexp_1));
                };
                addCssClassesToMetadataContainer({
                    condition: isMatchingSearchPhrase,
                    className: searchClassName,
                });
                addCssClassesToSvgText({
                    condition: isMatchingSearchPhrase,
                    className: searchClassName,
                });
                // count all results and set current search result for navigation
                var searchResults = svg.querySelectorAll("." + searchClassName);
                amountOfResults = searchResults.length;
                if (amountOfResults) {
                    currentResult = 1;
                    searchResults.forEach(function (item) {
                        item.classList.remove(currentSearchClassName);
                    });
                    var currentSearchResult = searchResults[0];
                    currentSearchResult.classList.add(currentSearchClassName);
                    zoomOnCurrentAsset(searchResults[0]);
                }
                _this.setState({
                    searchPhrase: value,
                    amountOfResults: amountOfResults,
                    currentResult: currentResult,
                });
            }
            if (handleSearchChange) {
                handleSearchChange(value);
            }
        };
        _this.state = initialState;
        _this.searchInput = React.createRef();
        return _this;
    }
    SVGViewerSearch.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.visible && this.props.visible) {
            this.setFocus();
        }
        if (prevProps.visible && !this.props.visible) {
            this.resetSearch();
        }
    };
    SVGViewerSearch.prototype.render = function () {
        var _this = this;
        var _a = this.props, isDesktop = _a.isDesktop, visible = _a.visible;
        if (!visible) {
            return null;
        }
        return (React.createElement(StyledSearch, { "data-test-id": "svg-viewer-search", onKeyDown: this.handleKeyDown, onMouseDown: function (e) { return e.stopPropagation(); }, onMouseUp: function (e) { return e.stopPropagation(); }, onClick: function (e) { return e.stopPropagation(); } },
            isDesktop ? (React.createElement(React.Fragment, null,
                React.createElement(SearchNavigationNext, { onClick: function () { return _this.handleNavigateSearchResult(1); }, "data-test-id": "next-result-svg" },
                    React.createElement(Icon, { type: "down" })),
                React.createElement(SearchNavigationPrev, { onClick: function () { return _this.handleNavigateSearchResult(-1); }, "data-test-id": "prev-result-svg" },
                    React.createElement(Icon, { type: "up" })))) : (React.createElement(Icon, { type: "arrow-left", onClick: this.handleCancelSearch, "data-test-id": "close-search-svg" })),
            React.createElement(SearchInputContainer, null,
                React.createElement(SearchInput, { value: this.state.searchPhrase, onChange: this.handleSearchPhraseChange, onFocus: this.props.onFocus, onBlur: this.props.onBlur, placeholder: "Search", ref: this.searchInput, "data-test-id": "search-input-svg" }),
                React.createElement(SearchResultsCounter, { hidden: !this.state.searchPhrase },
                    this.state.currentResult,
                    "/",
                    this.state.amountOfResults)),
            isDesktop && (React.createElement(CloseButton, { onClick: this.handleCancelSearch, "data-test-id": "close-search-svg" },
                React.createElement(Close, null))),
            !isDesktop && this.state.amountOfResults ? (React.createElement(React.Fragment, null,
                React.createElement(SearchNavigationNext, { onClick: function () { return _this.handleNavigateSearchResult(1); }, "data-test-id": "next-result-svg" },
                    React.createElement(Icon, { type: "down" })),
                React.createElement(SearchNavigationPrev, { onClick: function () { return _this.handleNavigateSearchResult(-1); }, "data-test-id": "prev-result-svg" },
                    React.createElement(Icon, { type: "up" })))) : null));
    };
    SVGViewerSearch.defaultProps = {
        searchClassName: 'search-result',
        currentSearchClassName: 'current-search-result',
    };
    return SVGViewerSearch;
}(React.Component));
var StyledSearch = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 65px;\n  padding: 5px 5px 5px 15px;\n  border-radius: 0;\n  background: #ffffff;\n  border-bottom: 1px solid #e8e8e8;\n\n  @media (min-width: 992px) {\n    top: 60px;\n    right: 20px;\n    width: auto;\n    height: auto;\n    padding-left: 5px;\n    border-radius: 5px;\n    border: 1px solid #bfbfbf;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 65px;\n  padding: 5px 5px 5px 15px;\n  border-radius: 0;\n  background: #ffffff;\n  border-bottom: 1px solid #e8e8e8;\n\n  @media (min-width: 992px) {\n    top: 60px;\n    right: 20px;\n    width: auto;\n    height: auto;\n    padding-left: 5px;\n    border-radius: 5px;\n    border: 1px solid #bfbfbf;\n  }\n"])));
var SearchNavigation = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  height: 100%;\n  background: none;\n  border: none;\n  font-size: 10px;\n  outline: none;\n  cursor: pointer;\n"], ["\n  position: relative;\n  height: 100%;\n  background: none;\n  border: none;\n  font-size: 10px;\n  outline: none;\n  cursor: pointer;\n"])));
var SearchNavigationPrev = styled(SearchNavigation)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: -5px;\n    width: 2px;\n    height: 100%;\n    background: #f5f5f5;\n  }\n"], ["\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: -5px;\n    width: 2px;\n    height: 100%;\n    background: #f5f5f5;\n  }\n"])));
var SearchNavigationNext = styled(SearchNavigation)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var SearchResultsCounter = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 0.875em;\n"], ["\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 0.875em;\n"])));
var SearchInput = styled.input(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  height: 30px;\n  outline: none;\n  border: none;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  width: 100%;\n  height: 30px;\n  outline: none;\n  border: none;\n\n  &:focus {\n    outline: none;\n  }\n"])));
var SearchInputContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 40px;\n\n  @media (min-width: 992px) {\n    width: 200px;\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 40px;\n\n  @media (min-width: 992px) {\n    width: 200px;\n  }\n"])));
var CloseButton = styled.button(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

var getDocumentDownloadLink = function (client, id) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, downloadUrl, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, client.files.getDownloadUrls([{ id: id }])];
            case 1:
                _a = __read.apply(void 0, [_b.sent(), 1]), downloadUrl = _a[0].downloadUrl;
                return [4 /*yield*/, client.get(downloadUrl, {
                        responseType: 'text',
                    })];
            case 2:
                data = (_b.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };

var zoomLevel = 0.7;
var wheelZoomLevel = 0.15;
var currentAssetClassName = 'current-asset';
var minDesktopWidth = 992;
var SVGViewer = /** @class */ (function (_super) {
    __extends(SVGViewer, _super);
    function SVGViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.prevMoveDistanceX = 0;
        _this.prevMoveDistanceY = 0;
        _this.dragging = false;
        _this.isOptimizationDisabled = false;
        _this.updateWindowDimensions = function () {
            _this.setState({
                width: window.innerWidth,
            });
        };
        _this.presetSVG = function () { return __awaiter(_this, void 0, void 0, function () {
            var customClassNames, svgString, documentId, file, e_1, parser, svgFromUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        customClassNames = this.props.customClassNames;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        documentId = this.props.documentId;
                        file = this.props.file;
                        if (!file) return [3 /*break*/, 2];
                        svgString = file;
                        return [3 /*break*/, 4];
                    case 2:
                        if (!documentId) return [3 /*break*/, 4];
                        return [4 /*yield*/, getDocumentDownloadLink(this.client, documentId)];
                    case 3:
                        svgString = _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        if (this.props.handleDocumentLoadError) {
                            this.props.handleDocumentLoadError(e_1);
                        }
                        return [3 /*break*/, 6];
                    case 6:
                        if (svgString) {
                            parser = new DOMParser();
                            // An SVG can contain Javascript, so run it through DOMPurify before
                            // embedding it in the DOM.
                            // Replace for svgs that has PNG inside
                            svgString = DOMPurify.sanitize(svgString.replace(/ns1:href/g, 'href'));
                            svgFromUrl = parser.parseFromString(svgString, 'image/svg+xml');
                            // if during parsing there was an error, svg will be rendered
                            // inside html tag until the line where an error occured,
                            // so we need to cover that case and show only svg
                            this.svg = svgFromUrl.getElementsByTagName('svg')[0];
                            if (this.svg) {
                                this.initiateScale();
                                this.initPinchToZoom();
                                this.initAttributesForMetadataContainer();
                                this.shouldDisableOptimization();
                                this.setCustomClasses();
                                this.svg.addEventListener('click', this.handleItemClick);
                                this.zoomOnCurrentAsset(document.querySelector("." + (currentAssetClassName || (customClassNames || {}).currentAsset)));
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.setCustomClasses = function () {
            if (_this.props.isCurrentAsset) {
                _this.addCssClassesToMetadataContainer({
                    condition: _this.props.isCurrentAsset,
                    className: currentAssetClassName ||
                        (_this.props.customClassNames || {}).currentAsset,
                });
            }
            if (_this.props.metadataClassesConditions) {
                _this.props.metadataClassesConditions.forEach(function (condition) {
                    _this.addCssClassesToMetadataContainer(condition);
                });
            }
        };
        _this.initiateScale = function () {
            if (_this.svgParentNode.current && _this.pinchZoomContainer.current) {
                var nonSvgChildrenHeight = Array.from(_this.svgParentNode.current
                    .childNodes)
                    .filter(function (node) { return !node.isEqualNode(_this.pinchZoomContainer.current); })
                    .reduce(function (acc, node) { return acc + node.clientHeight; }, 0);
                var svgNodeHeight = _this.svgParentNode.current.clientHeight - nonSvgChildrenHeight;
                _this.pinchZoomContainer.current.style.height = svgNodeHeight - 1 + "px";
            }
        };
        _this.initPinchToZoom = function () {
            if (_this.pinchZoom.current) {
                _this.pinchZoom.current.innerHTML = '';
                _this.pinchZoom.current.appendChild(_this.svg);
                _this.pinchZoomInstance = new PinchZoom(_this.pinchZoom.current, {
                    animationDuration: 0,
                    tapZoomFactor: 8,
                    maxZoom: _this.props.maxZoom,
                    minZoom: _this.props.minZoom,
                    setOffsetsOnce: true,
                });
            }
        };
        _this.initAttributesForMetadataContainer = function () {
            var metadataArray = _this.svg.querySelectorAll('metadata');
            Array.from(metadataArray).forEach(function (metadata) {
                var metadataContainer = metadata.parentNode;
                if (metadataContainer) {
                    metadataContainer.classList.add('metadata-container');
                    metadataContainer.setAttribute('data-test-id', 'metadata');
                    if (!_this.props.showOverlappedText) {
                        var textNodes = metadataContainer.querySelectorAll('text');
                        var className_1 = 'overlapped-text';
                        textNodes.forEach(function (textNode) {
                            textNode.classList.remove(className_1);
                            if (_this.isNullStrokeWidth(textNode)) {
                                textNode.classList.add(className_1);
                            }
                        });
                    }
                }
            });
        };
        _this.shouldDisableOptimization = function () {
            // Because willChange optimization has a calculation cost
            // we don't want to apply it for a bigger embedded into svg <image />
            // tags since it slows down the performance instead of providing
            // a boost. Images are already heavily optimized by browsers
            // so we don't need to care much about additional optimizations.
            var metadataArray = _this.svg.querySelectorAll('image');
            _this.isOptimizationDisabled = metadataArray.length > 0;
        };
        _this.onMouseDown = function (event) {
            if (!_this.pinchZoomInstance) {
                return;
            }
            _this.dragging = true;
            _this.pinchZoomInstance.stopAnimation();
            _this.startMouse = {
                x: event.pageX,
                y: event.pageY,
            };
        };
        _this.onMouseMove = function (event) {
            if (_this.dragging && _this.pinchZoomInstance) {
                event.preventDefault();
                var currentMoveDistanceX = event.pageX - _this.startMouse.x;
                var currentMoveDistanceY = event.pageY - _this.startMouse.y;
                _this.pinchZoomInstance.offset.x -=
                    currentMoveDistanceX - _this.prevMoveDistanceX;
                _this.pinchZoomInstance.offset.y -=
                    currentMoveDistanceY - _this.prevMoveDistanceY;
                _this.pinchZoomInstance.offset = _this.pinchZoomInstance.sanitizeOffset(_this.pinchZoomInstance.offset);
                _this.pinchZoomInstance.update();
                _this.prevMoveDistanceX = currentMoveDistanceX;
                _this.prevMoveDistanceY = currentMoveDistanceY;
            }
        };
        _this.onMouseUp = function () {
            var isDesktop = _this.state.width > minDesktopWidth;
            if (isDesktop && _this.inputWrapper.current) {
                _this.inputWrapper.current.focus();
            }
            _this.dragging = false;
            _this.prevMoveDistanceX = 0;
            _this.prevMoveDistanceY = 0;
        };
        // we need to remove and add back optimization as suggested here
        // https://developer.mozilla.org/en-US/docs/Web/CSS/will-change
        // so all the items will be rendered not blurry
        _this.onTouchStart = function () {
            if (_this.pinchZoom.current && !_this.isOptimizationDisabled) {
                // @ts-ignore 'willChange' is not a part of 'CSSStyleDeclaration'
                _this.pinchZoom.current.style.willChange = 'transform';
            }
        };
        _this.onTouchEnd = function () {
            if (_this.pinchZoom.current && !_this.isOptimizationDisabled) {
                // @ts-ignore 'willChange' is not a part of 'CSSStyleDeclaration'
                _this.pinchZoom.current.style.willChange = 'auto';
            }
        };
        _this.addCssClassesToMetadataContainer = function (_a) {
            var condition = _a.condition, className = _a.className;
            var metadataArray = _this.svg.querySelectorAll('metadata');
            Array.from(metadataArray).forEach(function (metadata) {
                var metadataContainer = metadata.parentNode;
                metadataContainer.classList.remove(className);
                if (condition(metadata)) {
                    metadataContainer.classList.add(className);
                }
            });
        };
        _this.addCssClassesToSvgText = function (_a) {
            var condition = _a.condition, className = _a.className;
            if (_this.svgParentNode.current) {
                var textNodes = _this.svgParentNode.current.querySelectorAll('svg > text, svg > g:not(.metadata-container) > text');
                textNodes.forEach(function (textNode) {
                    textNode.classList.remove(className);
                    if (condition(textNode)) {
                        textNode.classList.add(className);
                    }
                });
            }
        };
        _this.isNullStrokeWidth = function (textNode) {
            return textNode.getAttribute('stroke-width') === '0';
        };
        _this.handleItemClick = function (e) {
            var target = e.target;
            var parentNode = target.parentNode;
            if (parentNode && parentNode.classList.contains('metadata-container')) {
                _this.handleCancelSearch();
                if (_this.props.handleItemClick) {
                    _this.props.handleItemClick(parentNode);
                }
            }
            e.stopPropagation();
        };
        _this.handleTrackpadZoom = function (e) {
            if (e.ctrlKey) {
                e.preventDefault();
                e.stopPropagation();
                if (!_this.pinchZoomInstance) {
                    return;
                }
                _this.animateZoom(e.deltaY < 0 ? wheelZoomLevel : -wheelZoomLevel, 'trackpad', {
                    x: e.clientX,
                    y: e.clientY,
                });
            }
        };
        _this.animateZoom = function (zoomProgress, source, zoomCenter) {
            if (!_this.pinchZoomInstance) {
                return;
            }
            var startZoomFactor = _this.pinchZoomInstance.zoomFactor;
            var center = zoomCenter || {
                x: _this.pinchZoomInstance.container.clientWidth / 2,
                y: _this.pinchZoomInstance.container.clientHeight / 2,
            };
            var updateProgress = function (progress) {
                _this.pinchZoomInstance.scaleTo(startZoomFactor + progress * zoomProgress, center);
            };
            _this.pinchZoomInstance.animate(_this.pinchZoomInstance.options.animationDuration, updateProgress, _this.pinchZoomInstance.swing);
            if (_this.props.handleAnimateZoom) {
                _this.props.handleAnimateZoom({ zoomProgress: zoomProgress, source: source, zoomCenter: zoomCenter });
            }
        };
        _this.zoomOnCurrentAsset = function (currentAsset) {
            var isDesktop = _this.state.width > minDesktopWidth;
            if (!currentAsset || !_this.pinchZoomInstance) {
                return;
            }
            _this.pinchZoomInstance.zoomFactor = isDesktop
                ? zoomLevel * 3
                : zoomLevel * 10;
            // Need to wait until zoom applies to get proper offsets
            setTimeout(function () {
                var currentAssetPosition = currentAsset.getBoundingClientRect();
                if (currentAssetPosition) {
                    _this.pinchZoomInstance.offset = {
                        x: currentAssetPosition.left -
                            _this.pinchZoomInstance.container.clientWidth / 2 +
                            _this.pinchZoomInstance.offset.x,
                        y: currentAssetPosition.top -
                            _this.pinchZoomInstance.container.clientHeight / 2 +
                            _this.pinchZoomInstance.offset.y,
                    };
                    // Zoom may create invalid position
                    _this.pinchZoomInstance.offset = _this.pinchZoomInstance.sanitizeOffset(_this.pinchZoomInstance.offset);
                    _this.pinchZoomInstance.update();
                }
            });
        };
        _this.zoomIn = function () {
            _this.animateZoom(zoomLevel, 'topbar');
        };
        _this.zoomOut = function () {
            if (!_this.pinchZoomInstance) {
                return;
            }
            var zoomFactor;
            var startZoomFactor = _this.pinchZoomInstance.zoomFactor;
            if (startZoomFactor - zoomLevel > 1) {
                zoomFactor = startZoomFactor - zoomLevel;
            }
            else {
                zoomFactor = 1;
            }
            _this.animateZoom(zoomFactor - startZoomFactor, 'topbar');
        };
        _this.openSearch = function () {
            _this.setState({ isSearchVisible: true });
        };
        _this.handleCancelSearch = function () {
            _this.setState({
                isSearchVisible: false,
            });
        };
        _this.handleCloseModal = function () {
            if (_this.props.handleCancel) {
                _this.props.handleCancel();
            }
        };
        _this.handleSearchFocus = function () {
            _this.setState({ isSearchFocused: true });
        };
        _this.handleSearchBlur = function () {
            _this.setState({ isSearchFocused: false });
        };
        _this.onContainerClick = function () {
            var isDesktop = _this.state.width > minDesktopWidth;
            if (isDesktop && _this.inputWrapper.current) {
                _this.inputWrapper.current.focus();
            }
        };
        _this.onContainerBlur = function () {
            _this.setState({ handleKeyDown: false });
        };
        _this.onContainerFocus = function () {
            _this.setState({ handleKeyDown: true });
        };
        _this.handleKeyDown = function (e) {
            if (!_this.state.handleKeyDown) {
                return;
            }
            // Overriding ctrl+F
            var FKeyCode = 70;
            if ((e.ctrlKey || e.metaKey) && e.keyCode === FKeyCode) {
                e.preventDefault();
                _this.openSearch();
            }
        };
        _this.state = {
            isSearchVisible: false,
            isSearchFocused: false,
            handleKeyDown: false,
            width: window.innerWidth,
        };
        _this.pinchZoom = React.createRef();
        _this.pinchZoomContainer = React.createRef();
        _this.svgParentNode = React.createRef();
        _this.inputWrapper = React.createRef();
        return _this;
    }
    SVGViewer.prototype.componentDidMount = function () {
        this.client = this.context(SVGViewer.displayName || '');
        if (!this.client) {
            console.error(ERROR_NO_SDK_CLIENT);
            return;
        }
        this.presetSVG();
        window.addEventListener('resize', this.initiateScale);
        window.addEventListener('resize', this.updateWindowDimensions);
    };
    SVGViewer.prototype.componentDidUpdate = function (prevProps) {
        var prevDocId = prevProps.documentId;
        var currDocId = this.props.documentId;
        var prevFile = prevProps.file;
        var currFile = this.props.file;
        var prevMax = prevProps.maxZoom, prevMin = prevProps.minZoom;
        var _a = this.props, currMax = _a.maxZoom, currMin = _a.minZoom;
        if (this.svg) {
            this.setCustomClasses();
        }
        if ((currDocId !== undefined && currDocId !== prevDocId) ||
            (currFile !== undefined && currFile !== prevFile) ||
            currMax !== prevMax ||
            currMin !== prevMin) {
            this.presetSVG();
        }
    };
    SVGViewer.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.initiateScale);
        window.removeEventListener('resize', this.updateWindowDimensions);
    };
    SVGViewer.prototype.render = function () {
        var _a = this.props, title = _a.title, description = _a.description, _b = _a.customClassNames, customClassNames = _b === void 0 ? {} : _b, handleSearchChange = _a.handleSearchChange;
        var isDesktop = this.state.width > minDesktopWidth;
        var hasCloseButton = !!this.props.handleCancel;
        return (React.createElement(SVGViewerContainer, { onClick: this.onContainerClick, onKeyDown: this.handleKeyDown },
            isDesktop && (React.createElement("input", { type: "text", onBlur: this.onContainerBlur, onFocus: this.onContainerFocus, ref: this.inputWrapper, style: {
                    opacity: 0,
                    position: 'absolute',
                    pointerEvents: 'none',
                } })),
            React.createElement(SvgNode, { ref: this.svgParentNode, onMouseDown: this.onMouseDown, onMouseMove: this.onMouseMove, onMouseUp: this.onMouseUp, 
                // disable tap to search functionality for Android
                // https://developers.google.com/web/updates/2015/10/tap-to-search
                tabIndex: -1, onWheel: this.handleTrackpadZoom, customClassNames: customClassNames, "data-test-id": "svg-viewer" },
                (isDesktop || !this.state.isSearchVisible) && (React.createElement(StyledHeaderContainer, null,
                    hasCloseButton && (React.createElement(MobileModalClose, { "data-test-id": "close-svgviewer-btn", onClick: this.handleCloseModal },
                        React.createElement(Icon, { type: "arrow-left" }))),
                    React.createElement(StyledHeaderTitle, null,
                        title && React.createElement(StyledFileName, null, title),
                        description && (React.createElement(StyledHeaderDescription, null, description))),
                    React.createElement(StyledHeaderButtonsContainer, null,
                        React.createElement(ModalButton, { onClick: this.zoomIn, "data-test-id": "zoom-in-svgviewer" },
                            React.createElement(ZoomIn, null)),
                        React.createElement(ModalButton, { onClick: this.zoomOut, "data-test-id": "zoom-out-svgviewer" },
                            React.createElement(ZoomOut, null)),
                        React.createElement(ModalButton, { onClick: this.openSearch, "data-test-id": "search-button-svgviewer" },
                            React.createElement(FindInPage, null)),
                        hasCloseButton && (React.createElement(CloseModalButton, { onClick: this.handleCloseModal, "data-test-id": "close-svgviewer-btn" },
                            React.createElement(Close, null)))))),
                React.createElement(SVGViewerSearch, { visible: this.state.isSearchVisible, svg: this.svg, openSearch: this.openSearch, zoomOnCurrentAsset: this.zoomOnCurrentAsset, handleCancelSearch: this.handleCancelSearch, addCssClassesToMetadataContainer: this.addCssClassesToMetadataContainer, addCssClassesToSvgText: this.addCssClassesToSvgText, onFocus: this.handleSearchFocus, onBlur: this.handleSearchBlur, isDesktop: isDesktop, searchClassName: customClassNames.searchResults, currentSearchClassName: customClassNames.currentSearchResult, handleSearchChange: handleSearchChange }),
                React.createElement("div", { ref: this.pinchZoomContainer, style: !isDesktop && this.state.isSearchVisible
                        ? { top: '65px', position: 'relative' }
                        : {} },
                    React.createElement("div", { ref: this.pinchZoom, onTouchStart: this.onTouchStart, onTouchEnd: this.onTouchEnd })),
                !isDesktop && !this.state.isSearchFocused ? (React.createElement(ModalMobileFooter, null,
                    React.createElement(MobileSearchButton, { "data-test-id": "search-button-svgviewer", onClick: this.openSearch },
                        React.createElement(FindInPage, null)))) : null)));
    };
    SVGViewer.defaultProps = {
        maxZoom: 30,
        minZoom: 1,
    };
    SVGViewer.displayName = 'SVGViewer';
    SVGViewer.contextType = ClientSDKProxyContext;
    return SVGViewer;
}(Component));
var SVGViewerContainer = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  position: relative;\n"], ["\n  height: 100%;\n  width: 100%;\n  position: relative;\n"])));
var SvgNode = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  cursor: move;\n  overflow: auto;\n  height: 100%;\n  width: 100%;\n  background: #ffffff;\n  > svg {\n    display: block;\n  }\n  ", "\n  ", "\n  .metadata-container {\n    cursor: pointer;\n    > {\n      text {\n        transition: all 0.2s ease;\n        stroke: #000000;\n        fill: #000000;\n        stroke-width: 0.1;\n        text-decoration: underline;\n      }\n      text.overlapped-text {\n        fill: none;\n        stroke-width: 0;\n      }\n      path {\n        transition: stroke 0.2s ease;\n        pointer-events: bounding-box; /* increase hovering area */\n      }\n    }\n    &:hover,\n    &:focus > {\n      text {\n        stroke: #36a2c2;\n        fill: #36a2c2;\n      }\n      text.overlapped-text {\n        fill: none;\n        stroke-width: 0;\n      }\n      path {\n        stroke: #36a2c2;\n      }\n    }\n    ", "\n  }\n"], ["\n  cursor: move;\n  overflow: auto;\n  height: 100%;\n  width: 100%;\n  background: #ffffff;\n  > svg {\n    display: block;\n  }\n  ",
    "\n  ",
    "\n  .metadata-container {\n    cursor: pointer;\n    > {\n      text {\n        transition: all 0.2s ease;\n        stroke: #000000;\n        fill: #000000;\n        stroke-width: 0.1;\n        text-decoration: underline;\n      }\n      text.overlapped-text {\n        fill: none;\n        stroke-width: 0;\n      }\n      path {\n        transition: stroke 0.2s ease;\n        pointer-events: bounding-box; /* increase hovering area */\n      }\n    }\n    &:hover,\n    &:focus > {\n      text {\n        stroke: #36a2c2;\n        fill: #36a2c2;\n      }\n      text.overlapped-text {\n        fill: none;\n        stroke-width: 0;\n      }\n      path {\n        stroke: #36a2c2;\n      }\n    }\n    ",
    "\n  }\n"])), function (props) {
    return !props.customClassNames.searchResults &&
        "\n  .search-result {\n    &.metadata-container {\n      text {\n        stroke: #c945db !important;\n        fill: #c945db !important;\n        font-weight: bold;\n      }\n    }\n    &:not(.metadata-container) {\n      stroke: #c945db !important;\n      fill: #c945db !important;\n      font-weight: bold;\n    }\n  }";
}, function (props) {
    return !props.customClassNames.currentSearchResult &&
        "\n  .current-search-result {\n    &.metadata-container {\n      text {\n        stroke: #3838ff !important;\n        fill: #3838ff !important;\n      }\n    }\n    &:not(.metadata-container) {\n      stroke: #3838ff !important;\n      fill: #3838ff !important;\n    }\n  }";
}, function (props) {
    return !props.customClassNames.currentAsset &&
        "\n    &.current-asset {\n      outline: auto 2px #36a2c2;\n      cursor: default;\n      > {\n        text {\n          stroke: #36a2c2;\n          fill: #36a2c2;\n          transition: all 0.2s ease;\n          text-decoration: none;\n        }\n        path {\n          stroke: #36a2c2;\n          transition: all 0.2s ease;\n        }\n      }\n    }";
});
var StyledHeaderContainer = styled.div(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: nowrap;\n  height: 65px;\n  padding: 10px;\n  border-radius: 4px 4px 0 0;\n  background: #fff;\n  color: rgba(0, 0, 0, 0.65);\n  border-bottom: 1px solid #e8e8e8;\n\n  @media (min-width: 992px) {\n    padding: 5px 5px 5px 24px;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: nowrap;\n  height: 65px;\n  padding: 10px;\n  border-radius: 4px 4px 0 0;\n  background: #fff;\n  color: rgba(0, 0, 0, 0.65);\n  border-bottom: 1px solid #e8e8e8;\n\n  @media (min-width: 992px) {\n    padding: 5px 5px 5px 24px;\n  }\n"])));
var OverflowText = styled.div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
var StyledHeaderTitle = styled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  margin-right: 20px;\n  font-size: 1em;\n  font-weight: 600;\n  width: 100%;\n  overflow: hidden;\n"], ["\n  margin-right: 20px;\n  font-size: 1em;\n  font-weight: 600;\n  width: 100%;\n  overflow: hidden;\n"])));
var StyledHeaderDescription = styled(OverflowText)(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  font-size: 13px;\n  font-weight: 400;\n"], ["\n  font-size: 13px;\n  font-weight: 400;\n"])));
var StyledHeaderButtonsContainer = styled.div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StyledFileName = styled(OverflowText)(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  font-size: 16px;\n"], ["\n  font-size: 16px;\n"])));
var ModalButton = styled.button(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: none;\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  @media (min-width: 992px) {\n    display: inherit;\n  }\n"], ["\n  display: none;\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  @media (min-width: 992px) {\n    display: inherit;\n  }\n"])));
var CloseModalButton = styled(ModalButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  width: 45px;\n  margin-left: 10px;\n  border-left: 1px solid #f5f5f5;\n  padding-top: 10px;\n  padding-bottom: 10px;\n\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  width: 45px;\n  margin-left: 10px;\n  border-left: 1px solid #f5f5f5;\n  padding-top: 10px;\n  padding-bottom: 10px;\n\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"])));
var MobileModalClose = styled(ModalButton)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: inherit;\n  margin-right: 15px;\n\n  @media (min-width: 992px) {\n    display: none;\n  }\n"], ["\n  display: inherit;\n  margin-right: 15px;\n\n  @media (min-width: 992px) {\n    display: none;\n  }\n"])));
var ModalMobileFooter = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 65px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 15px;\n  background: #ffffff;\n  border-top: 1px solid #e8e8e8;\n"], ["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 65px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 15px;\n  background: #ffffff;\n  border-top: 1px solid #e8e8e8;\n"])));
var MobileSearchButton = styled.button(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  padding: 0;\n  background: none;\n  border: none;\n  outline: none;\n"], ["\n  padding: 0;\n  background: none;\n  border: none;\n  outline: none;\n"])));
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;

export { SVGViewer };
